export function dataSelector(dataResponse) {
  const filtered = dataResponse.data.map((item) => ({
    id: item.category_id,
    name: item.category_name,
    description: item.description,
    status: item.status,
  }));
  return { total: dataResponse.total, data: filtered };
}
